module.exports = __webpack_public_path__ + "static/media/(000157).6da44201.jpg";